import { useNavigate } from 'react-router-dom';
import { Sparkles, FileText, AlertTriangle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { FocusHeader } from '../components/FocusHeader';
import { useCreditsCheck } from '../hooks/useCreditsCheck';

export function NewBlogChoice() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const creditsInfo = useCreditsCheck(user?.id);

  if (!user) {
    return (
      <div className="min-h-screen bg-[#F2F2EF] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#FF6B35] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F2F2EF]">
      <FocusHeader
        title="Nieuwe Blog"
        onBack={() => navigate('/dashboard')}
      />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-bold text-[#231F20] mb-3">
            Hoe wil je starten?
          </h2>
          <p className="text-gray-600 text-lg">
            Kies hoe je jouw nieuwe blog wilt maken
          </p>
        </div>

        {!creditsInfo.isLoading && !creditsInfo.hasCredits && (
          <div className="max-w-3xl mx-auto mb-8 bg-red-50 border border-red-200 rounded-xl p-5 flex items-start gap-4">
            <AlertTriangle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold text-red-800">Onvoldoende credits om nieuwe blogs te maken</p>
              <p className="text-red-700 text-sm mt-1">
                Je hebt {creditsInfo.total} credits. Je kunt geen nieuwe blogs maken tot je credits zijn bijgevuld.
              </p>
              <button
                onClick={() => navigate('/dashboard/settings')}
                className="mt-3 px-4 py-2 bg-red-600 text-white text-sm font-semibold rounded-lg hover:bg-red-700 transition-colors"
              >
                Credits Aankopen
              </button>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <button
            onClick={() => creditsInfo.hasCredits && navigate('/idea-generate')}
            disabled={!creditsInfo.hasCredits}
            className={`group bg-white rounded-2xl p-8 border-2 transition-all text-left ${
              creditsInfo.hasCredits
                ? 'border-gray-200 hover:border-[#FF6B35] hover:shadow-xl cursor-pointer'
                : 'border-gray-200 opacity-50 cursor-not-allowed'
            }`}
          >
            <div className="flex flex-col items-center text-center">
              <div className={`w-20 h-20 bg-gradient-to-br from-[#FF6B35] to-[#E55A2B] rounded-2xl flex items-center justify-center mb-6 transition-transform ${creditsInfo.hasCredits ? 'group-hover:scale-110' : ''}`}>
                <Sparkles className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-[#231F20] mb-3">
                Genereer idee
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Laat AI een origineel blog idee voor je genereren op basis van jouw bedrijf en branche
              </p>
            </div>
          </button>

          <button
            onClick={() => creditsInfo.hasCredits && navigate('/text-import')}
            disabled={!creditsInfo.hasCredits}
            className={`group bg-white rounded-2xl p-8 border-2 transition-all text-left ${
              creditsInfo.hasCredits
                ? 'border-gray-200 hover:border-[#FF6B35] hover:shadow-xl cursor-pointer'
                : 'border-gray-200 opacity-50 cursor-not-allowed'
            }`}
          >
            <div className="flex flex-col items-center text-center">
              <div className={`w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mb-6 transition-transform ${creditsInfo.hasCredits ? 'group-hover:scale-110' : ''}`}>
                <FileText className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-[#231F20] mb-3">
                Ik heb al een tekst
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Plak je eigen tekst en laat AI deze verbeteren of volledig herschrijven
              </p>
            </div>
          </button>
        </div>
      </main>
    </div>
  );
}
